import React from 'react';
// import Particles from 'react-particles';
import { loadFull } from 'tsparticles';
import LoginForm from './LoginForm/LoginForm';
import DmarketLogo from '../../assets/Images/dmarket-logo.svg';
import PaternWhiteTop from '../../assets/Images/pattern_white_top.png';
import PaternWhiteBottom from '../../assets/Images/pattern_white_bottom.png';
import PaternGrayRight from '../../assets/Images/pattern_grey_rigth.png';
import PaternTopMobile from '../../assets/Images/pattern_top_mobile.png';
import { isMobile } from "react-device-detect";
import { CSSTransition } from 'react-transition-group';
import './LoginPage.scss';

const getFullYear = () => {
    var date = new Date(); // date object
    return date.getFullYear(); // get current year
}

// const Particles = !isMobile ? require('react-particles') : null;

const LoginPage = () => {

    const [Particles, setParticles] = React.useState(null);

    React.useEffect(() => {
        if (!isMobile) {
            import('react-particles').then((module) => {
                setParticles(() => module.default);
            });
        }
    }, []);

    const particlesInit = React.useCallback(async (engine) => {
        await loadFull(engine);
    }, []);

    const particlesOptions = {
        particles: {
            number: {
                value: 260,
                density: {
                    enable: false
                }
            },
            size: {
                value: 3,
                random: true,
                anim: {
                    speed: 100,
                    size_min: 0.4
                }
            },
            opacity: {
                value: 0.6, // Set opacity to 0.2 for more transparency
                random: true, // Randomize opacity
                anim: {
                    enable: true,
                    speed: 1, // Animation speed for opacity changes
                    opacity_min: 0.1, // Minimum opacity value
                    sync: false // Animate opacity asynchronously
                }
            },
            line_linked: {
                enable: false
            },
            move: {
                enable: true,
                speed: 1,
                direction: "top",
                random: true,
                straight: false,
                out_mode: "out",
                bounce: false
            }
        },
        interactivity: {
            events: {
                onhover: {
                    enable: true,
                    mode: "bubble"
                },
                onclick: {
                    enable: true,
                    mode: "repulse"
                }
            },
            modes: {
                bubble: {
                    distance: 250,
                    duration: 2,
                    size: 0,
                    opacity: 0
                },
                repulse: {
                    distance: 400,
                    duration: 4
                }
            }
        }
    };

    return (
        <div className='login-page-container'>
            <div className='top-section-mobile'>
                <div className='logo-container'>
                    <img className='dmarket-logo' src={DmarketLogo} alt='logo' />
                </div>
                <div className='patern-gary-right'>
                    <img className='gray-dots' src={PaternTopMobile} alt='rg' />
                </div>
            </div>

            <div className='left-section' style={{ position: 'relative' }}>
                {Particles && (
                    <Particles
                        id="tsparticles"
                        init={particlesInit}
                        options={particlesOptions}
                        style={{ position: 'absolute' }}
                    />
                )}

                <div className='left-section-content'>
                    <CSSTransition in={true} timeout={2500} classNames="dots-transition" appear>
                        <img className='white-top' src={PaternWhiteTop} alt='sqr' />
                    </CSSTransition>
                    <div className='login-header-container'>
                        <CSSTransition in={true} timeout={5500} classNames="list-transition" appear>
                            <div style={{ display: 'inherit', flexDirection: 'inherit' }}>
                                <img className='logo' src={DmarketLogo} alt='logo' />
                                <span className='welcome-txt'>Welcome to<br />DMarket</span>
                                <span className='description'>The marketplace for selling your diamonds</span>
                            </div>
                        </CSSTransition>
                    </div>
                    <CSSTransition in={true} timeout={2500} classNames="dots-transition" appear>
                        <img className='white-bottom' src={PaternWhiteBottom} alt='sqr' />
                    </CSSTransition>
                </div>
            </div>

            <LoginForm />

            <CSSTransition in={true} timeout={2500} classNames="dots-transition" appear>
                <img className='gray-right' src={PaternGrayRight} alt='sqr' />
            </CSSTransition>

            <div className='terms-and-conditions'>
                <span className='by-signing'>By signing you up agree to System</span>
                <span className='terms'>Terms and Conditions & Privacy Policy</span>
            </div>
            <div className='copyright'>Copyright © {getFullYear()} R2net.com. All rights reserved.</div>
        </div>
    )
}

export default LoginPage